import { render, staticRenderFns } from "./AccentMark.vue?vue&type=template&id=520f0f6a&"
import script from "./AccentMark.vue?vue&type=script&lang=js&"
export * from "./AccentMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports